import { useState, type CSSProperties } from 'react';

// 20 emoji nawiązujących do mistrzostw, piłki, rywalizacji i obstawiania.
// Domyślny default to 🏆 — zachowane z poprzedniej wersji (free-text input).
export const ROOM_EMOJI_OPTIONS = [
  '🏆', '⚽', '🥇', '🥈', '🥉',
  '🏅', '👑', '⭐', '🔥', '⚔️',
  '🥊', '💪', '🥅', '🏟️', '👟',
  '🎯', '🎲', '🃏', '🎰', '📊',
] as const;

function EmojiGrid({
  value,
  onChange,
}: {
  value: string;
  onChange: (emoji: string) => void;
}) {
  return (
    <div
      role="radiogroup"
      aria-label="Wybierz ikonę pokoju"
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(5, 1fr)',
        gap: 6,
      }}
    >
      {ROOM_EMOJI_OPTIONS.map((opt) => {
        const active = opt === value;
        return (
          <button
            key={opt}
            type="button"
            role="radio"
            aria-checked={active}
            aria-label={opt}
            onClick={() => onChange(opt)}
            style={{
              height: 44,
              borderRadius: 10,
              border: '1.5px solid',
              borderColor: active ? '#0f1e3d' : 'rgba(15,30,61,.1)',
              background: active ? 'rgba(15,30,61,.04)' : '#fff',
              fontSize: 22,
              lineHeight: 1,
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: 0,
              fontFamily: 'inherit',
              transition: 'border-color .15s, background .15s',
            }}
          >
            {opt}
          </button>
        );
      })}
    </div>
  );
}

export function EmojiPickerButton({
  value,
  onChange,
  size = 48,
  style,
}: {
  value: string;
  onChange: (emoji: string) => void;
  size?: number;
  style?: CSSProperties;
}) {
  const [open, setOpen] = useState(false);
  return (
    <div style={{ position: 'relative', width: size, ...style }}>
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        aria-haspopup="dialog"
        aria-expanded={open}
        aria-label={`Wybierz ikonę pokoju (aktualnie ${value})`}
        style={{
          width: size,
          height: size,
          borderRadius: 12,
          border: '1px solid rgba(15,30,61,.12)',
          background: '#fff',
          fontSize: Math.round(size * 0.5),
          lineHeight: 1,
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 0,
          fontFamily: 'inherit',
        }}
      >
        {value}
      </button>
      {open && (
        <>
          <div
            onClick={() => setOpen(false)}
            style={{ position: 'fixed', inset: 0, zIndex: 40 }}
          />
          <div
            role="dialog"
            aria-label="Wybór ikony"
            style={{
              position: 'absolute',
              top: 'calc(100% + 6px)',
              left: 0,
              zIndex: 50,
              width: 280,
              padding: 10,
              background: '#fff',
              border: '1px solid rgba(15,30,61,.1)',
              borderRadius: 12,
              boxShadow: '0 6px 20px rgba(15,30,61,.12)',
            }}
          >
            <EmojiGrid
              value={value}
              onChange={(e) => {
                onChange(e);
                setOpen(false);
              }}
            />
          </div>
        </>
      )}
    </div>
  );
}
